import { setLastAuthenticatedRoute } from '@/utils/authRedirect';
import { routeRequiresAuth } from './authGuard';

const defaultDocumentTitle = 'Profiteia.io';

export function createChromeBeforeEachGuard({ displayStore }) {
  return (to) => {
    displayStore.asideMobileToggle(false);
    displayStore.secondaryMenuToggle(null);

    if (displayStore.isAsideHiddenLayout) {
      displayStore.asideVisibilityToggle(false);
    }

    displayStore.formScreenToggle(!!to.meta.formScreen);
  };
}

export function createChromeAfterEachGuard({ authStore }) {
  return (to) => {
    if (authStore.isAuthenticated && routeRequiresAuth(to)) {
      setLastAuthenticatedRoute(to.fullPath);
    }

    if (to.meta && to.meta.title) {
      document.title = `${to.meta.title} — ${defaultDocumentTitle}`;
    } else {
      document.title = defaultDocumentTitle;
    }
  };
}
